<template> 
    <v-layout>
        
        <keep-alive>        
            <component 
                :is="mainform"
                :formdata="formdata"  
                v-on:submitcomplete="onSubmitComplete"
            ></component>

        </keep-alive>
        <formstopperdialog 
            :show="loading">            
        </formstopperdialog>
    </v-layout>
</template>
<script>
    import { mapGetters } from 'vuex';
    
    import formstopperdialog from "../components/forms/FormStopperDialog.vue";
    import mainform from "../components/forms/MainForm.vue";
    
    export default {   
    
    props: [
        
    ],
    components: {
        mainform,
        formstopperdialog,    
        
    },
    data() {
        return {  
            mainform:mainform,    
            formstopperdialog: formstopperdialog,
            loading:false,  
                              
        }
    },
    
    computed: {
        ...mapGetters({
            formdata: 'projects/formdata',
            
        }),
        routeid(){return this.$route.params.id},
        show(){return this.loading}
    },
    methods: {
        
        
        onSubmitComplete: function(submitted, id){   
                                    
            if(!submitted) {
                this.$router.push({ 
                name: 'projects'})
                
            } else {
                this.$router.push({ 
                name: 'projects_update', 
                params: { 
                        id: id 
                }})
            }
        },
               
        async init(){
            this.loading=true
            await Promise.all([ 
                this.$store.dispatch('tags/getAll'), 
                this.$store.dispatch('companies/getAll'),                                
                this.$store.dispatch('entities/getAll'),  
                this.$store.dispatch('projects/getAll'),  
            ])
        
            if(typeof this.$route.params.id != 'undefined') {   
                let payload = {}
                payload.needle = [parseInt(this.$route.params.id)]
                payload.res=[]                
                
                console.log('done')
            } 
        
            this.loading=false
        }
       
    },
    mounted() {
        this.init()
        
    }
    
    
}
</script>
